import React, { Component } from 'react';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { ActionType } from '../Store';

interface Props {
  name: string;
  onClick?: () => void;
}

export default class ActionIcon extends Component<Props> {
  render() {
    const { name, onClick } = this.props;
    return (
      <IconButton aria-label={name} onClick={onClick}>
        {name === ActionType.EDIT && <EditIcon />}
        {name === ActionType.DELETE && <DeleteIcon />}
      </IconButton>
    );
  }
}
